import React from 'react';
import './Footer.css';
import './Details.css';
import { Link } from 'react-router-dom';
import logo from '../Assets/logo.png';

function Footer() {
  // 👇 Set your app version here
  const APP_VERSION = 'v1.0.0'; // change as needed

  return (
    <footer>
      <div className="details-container">
        <div className="additional-links">
          <a href="https://support.tablemate.net" target='_blank' className="additional-link">Require Additional Support?</a>
          <br />
          <a href="/contact" className="additional-link">Contact Us</a>
        </div>
      </div>

      <div className="footer-main">
        <div className="footer-nav">
          <img className="tm-logo-footer" src={logo} alt="TM Logo" />
          <div className="footer-contact">
            <div>Info@tablemate.net</div>
            <div>+267 76020625</div>
            <div>PO Box 1697 Abg,</div>
            <div>Gaborone, Botswana</div>
          </div>
          <div className="footer-navigation-links">
            <Link to="https://tablemate.net">Visit Table Mate Website</Link>
          </div>
        </div>

        <div className="footer-copyright">
          <Link to="https://www.facebook.com/profile.php?id=61572710891118">
            <img
              style={{ maxHeight: '20px' }}
              className="facebook-logo-footer"
              src={`/Assets/fb_logo.png`}
              alt="Facebook Logo"
            />
          </Link>
          <Link to="https://x.com/tablemate_bw">
            <img
              style={{ maxHeight: '20px' }}
              className="x-logo-footer"
              src={`/Assets/x_logo.png`}
              alt="X Logo"
            />
          </Link>
          <Link to="https://www.instagram.com/tablemate_bw/">
            <img
              style={{ maxHeight: '20px' }}
              className="instagram-logo-footer"
              src={`/Assets/instagram_logo.png`}
              alt="Instagram Logo"
            />
          </Link>
          <Link to="https://www.linkedin.com/company/75034167/">
            <img
              style={{ maxHeight: '20px' }}
              className="linkedin-logo-footer"
              src={`/Assets/linkedin_logo.png`}
              alt="LinkedIn Logo"
            />
          </Link>

          <div>© Table Mate {new Date().getFullYear()}</div>
          {/* 👇 Version line */}
          <div className="footer-version">Back End Server App {APP_VERSION}</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
